module.exports = __webpack_public_path__ + "static/media/securityDeposit.ab7d7653.svg";